module.exports = __webpack_public_path__ + "img/separator13.62f09c63.svg";